import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/(private)/bando/$residenceId/verifiche')(
	{
		staticData: {
			breadcrumb: 'admin-arrivals:page_title'
		},
		component: () => <Outlet />
	}
)
